import { render, staticRenderFns } from "./ItemCardLoading.vue?vue&type=template&id=3eab62e4&scoped=true&"
import script from "./ItemCardLoading.vue?vue&type=script&lang=js&"
export * from "./ItemCardLoading.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardLoading.vue?vue&type=style&index=0&id=3eab62e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eab62e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VResponsive,VSkeletonLoader})
